import React from 'react';
const accreditations = [{
  name: 'DIA',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/74VdonxjsRCKSDkTRNoWFi/DIA.webp',
  tooltip: 'Driving Instructors Association'
}, {
  name: 'DVSA',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uGbpqzU3Ng2CPYsBPPhRxR/Driver__Vehcle_Standard_Agency.jpg',
  tooltip: 'Driver & Vehicle Standards Agency'
}, {
  name: 'DSA',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/58RrDLEZEn6HWCMS7F8Di9/DSA.jpg',
  tooltip: 'Driving Standards Agency Approved Driving Instructor (Car)'
}];
const Accreditations = () => {
  return <section className="py-12 bg-white" data-id="element-51">
      <div className="container mx-auto px-4" data-id="element-52">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-53">
          Our Accreditations
        </h2>
        <div className="flex flex-wrap justify-center gap-8 items-center" data-id="element-54">
          {accreditations.map(item => <div key={item.name} className="group relative" data-id="element-55">
              <img src={item.image} alt={`${item.name} - ${item.tooltip} - Northampton Driving School accreditation`} className="h-16 object-contain transition-all" data-id="element-56" />
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" data-id="element-57">
                {item.tooltip}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Accreditations;